import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SidebarLineItem } from '../../../line-item/sidebar-line-item';
import { useInventorySource } from '../../../../hooks/orders/use-inventory-source';

import style from './grouped-order-items.module.less';
import { messages } from './messages';
import { emptyArray } from 'ui-components/default-props/empty';

export const SidebarItemList = ({ items = emptyArray, fulfillmentPlanId, willInventoryShow = false, openProductDetailModal, children }) => {
  const { displayName, icon } = useInventorySource(fulfillmentPlanId);

  return (
    <>
      {children}
      <div className={style['item-list-header']}>
        <FormattedMessage {...messages.quantity} />
      </div>
      {willInventoryShow && (
        <div className={style['item-list-header']}>
          {icon &&
            React.cloneElement(icon, {
              className: style['third-party-logo'],
            })}
          {displayName ? <FormattedMessage {...displayName} /> : <FormattedMessage {...messages.inventory} />}
        </div>
      )}
      {items.map((item) => {
        return (
          <SidebarLineItem
            key={item.fulfillmentPlanItemId}
            fulfillmentPlanId={fulfillmentPlanId}
            openProductDetailModal={openProductDetailModal}
            orderItem={item}
            willInventoryShow={willInventoryShow}
          />
        );
      })}
    </>
  );
};

SidebarItemList.propTypes = {
  items: PropTypes.array,
  fulfillmentPlanId: PropTypes.string.isRequired,
  willInventoryShow: PropTypes.bool,
  openProductDetailModal: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
